// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const Assessment = require("assessments/models/assessment").default
const AssessmentForUser =
  require("assessments/models/assessment-for-user").default

export default Pathwright.module(
  "AssessmentContentModule",
  function (AssessmentContentModule, App, Backbone, Marionette, $, _) {
    this.startWithParent = false

    let currentAssessment = null

    window.App.reqres.setHandler("get:assessment", function (id, context) {
      let assessment
      ;`\
Gets an assessment content model for the given context
@param {String} id: The ID of the assessment to load 
@param {Object} context: The context in which the assessment is being loaded
  @option context {String} stepID: The step the assessment is being loaded from. Used for permissions.
  @option context {String} userID: The ID of the user to load the assessment under (e.g. you will see this user's answers). 
    Defaults to the current user if not provided.\
`

      const d = new $.Deferred()
      const ops = {
        id,
        stepID: context.stepID,
        step_id: context.stepID,
        assessmentID: id,
        type: "assessment",
        isAdmin: (context.isAdmin != null) === true,
        isReview: (context.isReview != null) === true
      }

      // If this is a completed step, review mode is always on
      if (context.stepCompleted) {
        ops.isReview = true
      }

      ops.context = {
        sid: ops.stepID,
        userID: context.userID,
        stepID: ops.stepID
      }

      if (ops.context.userID) {
        assessment = new AssessmentForUser(
          { id, step_id: context.stepID, userID: ops.context.userID },
          ops
        )
      } else {
        assessment = new Assessment({ id, step_id: context.stepID }, ops)
      }

      window.assessment = assessment

      if (context.userID != null) {
        assessment.set("userID", context.userID)
      }

      assessment
        .fetch()
        .then(function () {
          currentAssessment = assessment
          return d.resolve(currentAssessment)
        })
        .fail((err) => d.reject(err))
      return d.promise()
    })

    return window.App.reqres.setHandler(
      "get:current:assessment",
      () => currentAssessment
    )
  }
)
